import { axiosInstance } from "./../shared/services/axios-instance"
import * as endpoints from "../constants/api-constants"

class GameServices {
  static getTop(gameId, config) {
    return axiosInstance
      .get(endpoints.getTop + "/" + gameId, config)
      .then(resp => resp.data)
  }

  static getTokenGame(gameId, config) {
    return axiosInstance
      .get(endpoints.getTokenGame + "/" + gameId, config)
      .then(resp => resp.data)
  }

  static postGameParticipationRedeem(gameId, config) {
    return axiosInstance
      .post(endpoints.postGameParticipationRedeem + "/" + gameId, {}, config)
      .then(resp => resp.data)
  }

  static postGameParticipationSave(payload, config) {
    return axiosInstance
      .post(
        endpoints.postGameParticipationSave + "/" + payload.gameId,
        payload,
        config
      )
      .then(resp => resp.data)
  }
}

export default GameServices
